import * as React from 'react';
import { MediaQuery, SliderCarousel } from '@grandvisionhq/common';

const ProductBlockSlider = ({ blockKeys , renderBlock  })=>{
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement(SliderCarousel, {
        itemWidth: isPhone ? 186 : 246
    }, blockKeys.map((blockKey)=>renderBlock({
            blockKey,
            className: 'slideable-product-block'
        })
    ));
};

export { ProductBlockSlider };
//# sourceMappingURL=ProductBlockSlider.js.map
